import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import ProductIntro from "@/components/site/ProductIntro";
import Advantages from "@/components/site/Advantages";
import ColorShowcase from "@/components/site/ColorShowcase";
import Specs from "@/components/site/Specs";
import CrossSection from "@/components/site/CrossSection";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-[#0A0A0A] text-white" data-testid="landing-page">
      <Header />
      <Hero />
      <ProductIntro />
      <Advantages />
      <ColorShowcase />
      <Specs />
      <CrossSection />
      <Contact />
      <Footer />
    </main>
  );
}
